export default "__VITE_ASSET__DlXv$Ydt__"